import { render, staticRenderFns } from "./UserAddForm.vue?vue&type=template&id=728f26d1"
import script from "./UserAddForm.vue?vue&type=script&lang=js"
export * from "./UserAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports